import store from '@/store'

export default function({ next, from }) {
  if (!store.getters.authenticated) {
    next()
  } else {
    next(from.fullPath)
  }
}
